import DefineType from '../../../shareUI/defineType/defineType'
import DefineDirector from '../../../shareUI/defineDirector/defineDirector'
import * as defineTypeFormTypes from './defineProjectType'
import useDefineTypeForm from './useDefineProject'

import Grid from '@material-ui/core/Grid'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import DesignateReviewer from '../../../shareUI/designateReviewer/designateReviewer'
import constSubmittedType from '../../../../../constants/submittedType'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import Dialog from '../../../../../control/dialog/dialog'
import useCheckPermission from '../../../../../utilities/checkPermission'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'

//View
const DefineProjectView = (props: defineTypeFormTypes.DefineTypeFormTypesViewType) => {
    const {
        formRef,
        projectData,
        isViewMode,
        initialValues,
        required,
        configDialog,
        isShowUpdateDate,
        isEditDirector,
        onRefDialog,
        onChangProjectType,
        onDirtyChange,
        onSubmitForm,
        onClickBackToSearch,
    } = props

    const translate = useTranslate()
    const checkPermission = useCheckPermission()
    const irb = projectData?.irb
    const irbType = projectData?.irbType
    const isShowReviewer = checkPermission.isUserAdmin()

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, submitType: null }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                formRef.current = formProps
                const isNotAboutPeople: boolean = formProps?.values?.isNotAboutPeople ?? false
                const isFlowNewProject: boolean =
                    projectData?.submitTypeInfo?.value === constSubmittedType.firstSubmitConsideration

                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <DefineType
                                    disabled={isViewMode}
                                    isNotAboutPeople={isNotAboutPeople}
                                    isShowFieldNotAboutPeople={isFlowNewProject}
                                    onChang={(val) => {
                                        onChangProjectType(val)
                                    }}
                                    projectData={projectData}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <DefineDirector
                                    irb={irb}
                                    irbType={irbType}
                                    // disabled={isViewMode || isNotAboutPeople}
                                    disabled={(!isEditDirector && isViewMode) || isNotAboutPeople}
                                    reqField={(required && !isNotAboutPeople) || isEditDirector}
                                    projectData={projectData}
                                    // isDisableRole={isViewMode || isNotAboutPeople}
                                    isDisableRole={(!isEditDirector && isViewMode) || isNotAboutPeople}
                                />
                            </Grid>

                            {isShowReviewer && (
                                <Grid item xs={12}>
                                    <DesignateReviewer
                                        irb={irb}
                                        isViewMode={isViewMode || isNotAboutPeople}
                                        reqField={!isNotAboutPeople}
                                        title={translate.get('LABEL.DEFINE_REVIEWER')}
                                        label={translate.get('LABEL.REVIEWER_NAME')}
                                    />
                                </Grid>
                            )}

                            {isShowUpdateDate && <DisplayUpdater />}

                            {!isViewMode && (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={
                                            isEditDirector
                                                ? undefined
                                                : () => {
                                                      formProps.form.change('submitType', 'draft')
                                                      formProps.handleSubmit()
                                                  }
                                        }
                                        onClickSave={() => {
                                            formProps.form.change('submitType', 'save')
                                            formProps.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <FormSpy subscription={{ values: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}

//Controller
const DefineTypeForm = (props: defineTypeFormTypes.DefineTypeFormTypesType) => {
    const useDefineTypeModel = useDefineTypeForm(props)
    return <DefineProjectView {...useDefineTypeModel} {...props} />
}
export default DefineTypeForm
